import * as actionsType from "../actions/types";

const initialState = {
    listing: null,
    listingsize: null,
    bidding: null,
    details: null,
    catData: null
};

export default function productDetailsReducer(state = initialState, action) {
    switch (action.type) {
        case actionsType.SET_PRODUCT_DETAILS:
            const { details } = action.payload;
            return { ...state, details }


        case actionsType.SET_PRODUCTS:
            return { ...state, details: action.payload }

        case actionsType.SET_PRODUCTS_LISTING:
            return { ...state, listing: action.payload.data,listingsize:action.payload.unSkippedSize }


        case actionsType.SET_PRODUCTS_BIDDING:
            return { ...state, bidding: action.payload }

        case actionsType.SET_CAT_DATA:
            return { ...state, catData: action.payload.values, };

        case actionsType.LOGOUT_SUCCESS:
            const newStates = state;
            newStates.listing = null;
            newStates.bidding = null;
            newStates.catData = null;
            return { ...newStates };

        case actionsType.DEL_PRODUCTS:
            const { idList } = action.payload;
            const newState = state.listing;
            for (let i = 0; i < idList.length; i++) {
                let index = newState.findIndex(item => item._id == idList[i]);
                newState.splice(index, 1);
            }
            return { ...state, listing: newState, };

        case actionsType.UPDATE_SELLER_PRODUCT:
            const { product } = action.payload;
            return { ...state, details: product, };


        case actionsType.UPDATE_PRODUCT_DETAIL:
            return { ...state, details:{...state.details,...action.payload} };

        default:
            return state;
    }
}